import { render, staticRenderFns } from "./DataHealthModal.vue?vue&type=template&id=4986ec56&scoped=true"
import script from "./DataHealthModal.vue?vue&type=script&lang=js"
export * from "./DataHealthModal.vue?vue&type=script&lang=js"
import style0 from "./DataHealthModal.vue?vue&type=style&index=0&id=4986ec56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986ec56",
  null
  
)

export default component.exports